import { render, staticRenderFns } from "./SelfItem.vue?vue&type=template&id=9cb6d28a&scoped=true&"
import script from "./SelfItem.vue?vue&type=script&lang=js&"
export * from "./SelfItem.vue?vue&type=script&lang=js&"
import style0 from "./SelfItem.vue?vue&type=style&index=0&id=9cb6d28a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb6d28a",
  null
  
)

export default component.exports